import React, { useEffect, useState } from "react";
import { useLang } from "../../contexts/LanguageContext";
import { api } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";

export default function AdminStudents() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/students").then(r => setItems(r.data)); }, []);

  return (
    <div data-testid="admin-students">
      <p className="overline mb-1">OFA France · Admin</p>
      <h1 className="font-serif text-3xl tracking-tight mb-6">{t("admin.students")}</h1>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary/50 text-xs uppercase tracking-wider text-muted-foreground">
              <tr><th className="p-3 text-left">Student</th><th className="p-3 text-left">Grade</th><th className="p-3 text-left">FR</th><th className="p-3 text-left">EN</th><th className="p-3 text-left">Family</th></tr>
            </thead>
            <tbody>
              {items.map(s => (
                <tr key={s.id} data-testid={`student-row-${s.id}`} className="border-t border-border">
                  <td className="p-3 font-medium">{s.first_name} {s.last_name}</td>
                  <td className="p-3"><Badge variant="outline">{s.grade || "—"}</Badge></td>
                  <td className="p-3 text-xs">{s.french_level ? t(`levels.${s.french_level}`) : "—"}</td>
                  <td className="p-3 text-xs">{s.english_level ? t(`levels.${s.english_level}`) : "—"}</td>
                  <td className="p-3 text-xs">{s.family?.parent_first_name} {s.family?.parent_last_name} <span className="text-muted-foreground">· {s.family?.country}</span></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan="5" className="p-8 text-center text-muted-foreground">No students</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
